export const FIND_RESULT_RATINGS_REQUEST = 'FIND_RESULT_RATINGS_REQUEST';

export const findResultRatingsRequest = ({
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_RESULT_RATINGS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
        pagination,
    }
});
